/** Canonical OAF extension discriminators shared by AI Skill and Plugin readers. */
export const AI_SKILL_EXTENSION_TYPE = 'listing/extensions/ai-skill/listings/Listing';
export const AI_PLUGIN_EXTENSION_TYPE = 'listing/extensions/ai-plugin/listings/Listing';

export const AI_TECHNOLOGY_EXTENSION_MAP = {
    'ai-skill': AI_SKILL_EXTENSION_TYPE,
    'ai-plugin': AI_PLUGIN_EXTENSION_TYPE,
} as const;
